import type { MeetingTypeVariant } from './meetingAccessPolicy';

export interface MeetingAccessPayload {
  restricted: boolean;
  domains: string[];
  options: Record<string, unknown>;
}

export const createMembersOnlyOptions = (membersOnly: boolean): Record<string, unknown> => {
  return {
    members_only: membersOnly,
  };
};

export const createMeetingAccessPayload = (
  meetingType: MeetingTypeVariant,
  userDomain: string,
): MeetingAccessPayload => {
  switch (meetingType) {
    case 'standard':
      return {
        restricted: false,
        domains: [userDomain],
        options: createMembersOnlyOptions(true),
      };
    case 'private':
      return {
        restricted: false,
        domains: [],
        options: createMembersOnlyOptions(true),
      };
    case 'open':
      return {
        restricted: true,
        domains: [],
        options: createMembersOnlyOptions(false),
      };
  }
};
